import Mtop from '@ali/arise-h5-utils-mtop';

export async function subscribe(data = {}) {
  try {
    const res = await Mtop.request({
      api: 'mtop.global.legal.personaldata.authorized.save',
      v: '1.0',
      type: 'POST',
      data,
    });
    return res;
  } catch (e) {
    return {
      api: 'mtop.global.legal.personaldata.authorized.save',
      data: {
        status: 0, // 1表示成功
      },
      ret: ['SUCCESS::调用成功'],
      v: '1.0',
    };
  }
}
